import { Component } from 'opus-angular-seed-core';
import ePub from 'epubjs';
import $ from 'jquery';

@Component({
    bindings: {
        scormSubmission: '=',
        viewOnly: '='
    },
    template: `
        <div
            class="scorm-container epub"
            ng-class="{ 'menu-visible': vm.menuVisible }"
        >
            <div class="topbar">
                <div class="burger"></div>
                <div class="middle-content">
                    <div class="progress-wrapper">
                        <progress value="{{ vm.progress }}" max="100" />
                        <label
                            >{{ 'materials.Completed' | translate }}
                            {{ vm.progress }}%</label
                        >
                    </div>
                </div>
                <div class="close-icon" ng-click="vm.close()"></div>
            </div>
            <loader-icon ng-if="vm.loading"></loader-icon>
            <div class="materials-wrapper">
                <div class="content">
                    <div class="content-panel">
                        <div class="epub-reader-wrapper">
                            <div
                                class="epub-click-region left"
                                ng-click="vm.previous()"
                            ></div>
                            <div
                                class="epub-click-region center"
                                ng-click="vm.toggleMenu()"
                            ></div>
                            <div
                                class="epub-click-region right"
                                ng-click="vm.next()"
                            ></div>
                            <div id="reader" class="epub-reader"></div>
                        </div>
                    </div>
                    <div class="content-footer">
                        <button
                            class="secondary-button"
                            ng-click="vm.previous()"
                        >
                            {{ 'general.Previous' | translate }}
                        </button>
                        <button
                            id="nextButton"
                            class="main-button"
                            ng-click="vm.next()"
                            ng-disabled="vm.loading"
                        >
                            {{ 'materials.Next' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor (
        ScormSubmissionResource,
        ModalService,
        $translate,
        $state,
        $scope,
        $sce,
        $window,
        $timeout,
        OccurrenceResource,
        toastr,
        $interval,
        COURSE_PROGRESS_STATUS_TYPE_ENUM,
        COURSE_TRAINING_MATERIAL_TYPE_ENUM
    ) {
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.ScormSubmissionResource = ScormSubmissionResource;
        this.OccurrenceResource = OccurrenceResource;
        this.ModalService = ModalService;
        this.$state = $state;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$window = $window;
        this.form = this.scormSubmission;
        this.$timeout = $timeout;
        this.toastr = toastr;
        this.$interval = $interval;

        $('#loading-bar').hide();

        this.inFrame = self !== top;
        this.userAgent = $window.navigator.userAgent;
        this.isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                this.userAgent
            );
    }

    $onInit () {
        this.currentState = null;
        this.progress = 0;
        this.loading = true;
        this.menuVisible = false;

        this.$timeout(() => {
            this.initBook();
            this.initSwipeGestures();
        }, 200);

        this.keydownHandler = (event) => {
            if (event.key === 'ArrowLeft') {
                this.previous();
            }
            else if (event.key === 'ArrowRight') {
                this.next();
            }
        };
        document.addEventListener('keydown', this.keydownHandler);

        const company = this.scormSubmission.user.company;
        this.initCompanyColorScheme(company);
        this.startDeadlineCheck();
    }

    initCompanyColorScheme (company) {
        if (company.brandColor !== null) {
            document.documentElement.style.setProperty(
                '--brand-main',
                company.brandColor
            );
        }
    }

    $onDestroy () {
        this.stopDeadlineCheck();
        if (this.keydownHandler) {
            document.removeEventListener('keydown', this.keydownHandler);
        }
        if (this.touchStartHandler) {
            this.readerElement.removeEventListener(
                'touchstart',
                this.touchStartHandler
            );
        }
        if (this.touchEndHandler) {
            this.readerElement.removeEventListener(
                'touchend',
                this.touchEndHandler
            );
        }
    }

    initSwipeGestures () {
        this.readerElement = document.querySelector('.epub-reader-wrapper');
        if (!this.readerElement) return;

        let touchstartX = 0;
        let touchstartY = 0;
        const minSwipeDistance = 50; // Minimum distance in pixels to trigger swipe

        this.touchStartHandler = (e) => {
            touchstartX = e.changedTouches[0].screenX;
            touchstartY = e.changedTouches[0].screenY;
        };

        this.touchEndHandler = (e) => {
            const touchendX = e.changedTouches[0].screenX;
            const touchendY = e.changedTouches[0].screenY;

            const deltaX = touchendX - touchstartX;
            const deltaY = touchendY - touchstartY;

            if (
                Math.abs(deltaX) <= Math.abs(deltaY) ||
                Math.abs(deltaX) <= minSwipeDistance
            ) {
                return;
            }

            this.$timeout(() => {
                if (deltaX < 0) {
                    this.next();
                    return;
                }
                this.previous();
            });
        };

        this.readerElement.addEventListener(
            'touchstart',
            this.touchStartHandler
        );
        this.readerElement.addEventListener('touchend', this.touchEndHandler);
    }

    removeLoading () {
        this.loading = false;
        this.$timeout(() => {
            this.$scope.$apply();
        });
    }

    initBook () {
        const url = this.getEpubUrl();
        const readerContainer = document.getElementById('reader');

        this.book = ePub(url);

        this.rendition = this.book.renderTo(readerContainer, {
            width: '100%',
            height: this.isMobile ? '100vh' : 'calc(100vh - 71px - 81px)'
        });

        if (this.scormSubmission.state === null || this.viewOnly === '1') {
            this.rendition.display().then(() => {
                this.generateLocations();
            });
            return;
        }
        this.rendition.display(this.scormSubmission.state).then(() => {
            this.generateLocations();
        });
    }

    generateLocations () {
        this.book.ready.then(() => {
            this.book.locations.generate(2000).then(() => {
                this.updateProgress();
            });
        });
    }

    updateProgressBar (progress) {
        const progressBar = document.getElementById('progressBar');
        const progressText = document.getElementById('progressText');
        progressBar.style.width = `${progress}%`;
        progressText.textContent = `${progress}%`;
    }

    markProgress () {
        if (this.viewOnly === '1') {
            this.removeLoading();
            return;
        }

        this.form.type = 'EPUB';
        this.form.state = this.currentState;
        this.form.progressJson = { progress: this.progress };
        this.ScormSubmissionResource.update(
            { guid: this.scormSubmission.guid },
            this.form
        ).$promise.finally(() => {
            this.removeLoading();
        });
    }

    finish () {
        this.markProgress();
        this.close();
    }

    toggleMenu () {
        this.menuVisible = !this.menuVisible;
    }

    closeModalWindow () {
        parent.postMessage('action:closeMaterialDialog', '*');
    }

    close () {
        if (this.inFrame) {
            this.closeModalWindow();
            return;
        }
        window.close();
    }

    handleButtonsText (progress) {
        const button = document.getElementById('nextButton');

        if (progress === 100) {
            button.textContent = this.$translate.instant('materials.Complete');
            return;
        }

        button.textContent = this.$translate.instant('materials.Next');
    }

    isLastPage (location) {
        const currentLocationIndex = this.book.locations.locationFromCfi(
            location.start.cfi
        );
        const totalLocations = this.book.locations.total;

        if (
            currentLocationIndex + 1 >= totalLocations &&
            totalLocations !== 0
        ) {
            return true;
        }

        const nextLocationCfi = this.book.locations.cfiFromLocation(
            currentLocationIndex + 1
        );

        return nextLocationCfi === location.start.cfi;
    }

    getProgress (location) {
        if (this.isLastPage(location)) {
            return 100;
        }
        return Math.ceil(
            this.book.locations.percentageFromCfi(location.start.cfi) * 100
        );
    }

    next () {
        if (this.progress === 100) {
            this.finish();
            return;
        }

        this.rendition.next().then(() => {
            this.updateProgress();
        });
    }

    previous () {
        this.rendition.prev().then(() => {
            this.updateProgress();
        });
    }

    updateProgress () {
        const currentLocation = this.rendition.currentLocation();
        this.currentState = currentLocation.start.cfi;
        this.progress = this.getProgress(currentLocation);

        this.markProgress();
        this.handleButtonsText(this.progress);
    }

    getEpubUrl () {
        return `${SEED_CORE.ENV.API_URL}scorm/${this.scormSubmission.guid}/${this.scormSubmission.scorm.name}`;
    }

    handleOverdueDeadline () {
        return this.OccurrenceResource.handleOverdueDeadline(
            {},
            {
                guid: this.scormSubmission.guid,
                materialType: this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM,
                occurrenceTrainingId: this.scormSubmission.occurrenceTrainingId
            }
        ).$promise.then((response) => response.status === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_PASSED);
    }

    startDeadlineCheck () {
        if (this.viewOnly === '1') {
            return;
        }

        this.deadlineCheckInterval = this.$interval(() => {
            this.handleOverdueDeadline().then((isNotPassed) => {
                if (isNotPassed) {
                    this.stopDeadlineCheck();
                    this.toastr.error(
                        this.$translate.instant('materials.Failed to pass the course before the deadline')
                    );
                    setTimeout(() => {
                        this.close();
                    }, 2000);
                }
            });
        }, 60000);
    }

    stopDeadlineCheck () {
        if (this.deadlineCheckInterval) {
            this.$interval.cancel(this.deadlineCheckInterval);
            this.deadlineCheckInterval = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/scorm/player/epub/index.js